export interface ViewCartGTMEventProps {
    currency: string;
    value: string;
    items: {
        index: number;
        name: string;
        id: string;
        price: number;
        brand: string;
        category: string;
        quantity: number;
        item_id: string;
        item_variant: string;
        discount: string;
    }[]
}

export default function viewCartGTMEvent(event: ViewCartGTMEventProps) {
    if ((window as any)?.dataLayer === undefined) {
        return;
    }
    (window as any).dataLayer.push({ ecommerce: null });
    (window as any).dataLayer.push({
        event: 'view_cart',
        value: event.value,
        currency: event.currency,
        items: event.items
    });
}
